import $ from "jquery";
import axios from "axios";
import { toast } from "react-toastify";

import { BACKEND_CONFIG } from "../../config/consts";

export const onTableInitComplete = () => {
  addArchiveHandler();
  addChangeUserHandler();
};

export const reloadClientTable = (isReload) => {
  $("#tblClients").DataTable().ajax.reload(null, isReload);
};

const addArchiveHandler = () => {
  $("#dvClients").on("change", ".cb-is-archived", (sender) => {
    blockClientsTable();
    var isArchived = sender.target.checked;
    var clientId = $(sender.target).data("clientid");

    axios
      .patch(getArchiveUrl(clientId, isArchived))
      .then((data) => {
        toast.success(
          isArchived ? "Client was archived." : "Client was unarchived.",
          {
            position: toast.POSITION.TOP_RIGHT,
          }
        );
        reloadClientTable();
      })
      .catch((response) => {
        sender.target.checked = !sender.target.checked;
        toast.error("Something went wrong. Please try again.", {
          position: toast.POSITION.TOP_RIGHT,
        });
        unblockClientsTable();
      });
  });
};

const addChangeUserHandler = () => {
  $("#dvClients").on("click", "#ddlAgencyUser", function () {
    blockClientsTable();

    var ddToggle = $(this).parent().prev("button");

    ddToggle.find("#content").text($(this).text());

    var clientId = $(ddToggle).data("clientid");
    var userId = $(this).val();

    axios
      .patch(getChangeUserUrl(clientId, userId))
      .then((data) => {
        toast.success("Client was reassigned.", {
          position: toast.POSITION.TOP_RIGHT,
        });
        unblockClientsTable();
      })
      .catch((error) => {
        toast.error("Something went wrong. Please try again.", {
          position: toast.POSITION.TOP_RIGHT,
        });
        unblockClientsTable();
      });
  });
};

const getChangeUserUrl = (clientId, userId) => {
  return (
    BACKEND_CONFIG.apiUrl +
    "agency/clients/" +
    clientId +
    "/user/" +
    userId +
    "/change"
  );
};

const getArchiveUrl = (clientId, isArchived) => {
  var toArchive = isArchived ? "archive" : "unarchive";

  return BACKEND_CONFIG.apiUrl + "agency/clients/" + clientId + "/" + toArchive;
};

const blockClientsTable = () => {
  //$('#dvClients').block();
};

const unblockClientsTable = () => {
  //$('#dvClients').unblock();
};
